export default {
  SET_DIRECTORIES(state, directories) {
    state.directories = directories;
  },
  SET_DIRECTORY(state, directory) {
    state.directory = directory;
  },
};
